import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/views/Dashboard.vue";
import Database from "@/views/Database.vue";
import Billing from "@/views/Billing.vue";
import Tutorials from "@/views/Tutorials.vue";
import Generate from "@/views/Generate.vue";
import Connections from "@/views/Connections.vue";
import Profile from "@/views/Profile.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import ChangePassword from "@/views/ChangePass.vue";
import ResetPassword from "@/views/ResetPass.vue";
import ResetPasswordAfterMail from "@/views/ResetPassAfterMail.vue";
import Packs from "@/views/Paquetes.vue";
import SuccessPayment from "@/views/SuccessPayment.vue";
import FailPayment from "@/views/FailPayment.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/database",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/database",
    name: "Database",
    component: Database,
  },
  {
    path: "/generate",
    name: "Generate",
    component: Generate,
  },
  {
    path: "/connections",
    name: "Connections",
    component: Connections,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/tutorials",
    name: "Tutorials",
    component: Tutorials,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
  },
  {
    path: "/change-password",
    name: "Change Password",
    component: ChangePassword,
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: ResetPassword,
  },
  {
    path: "/reset-password-after-mail",
    name: "Reset Password After Mail",
    component: ResetPasswordAfterMail,
  },
  {
    path: "/packs",
    name: "Packs",
    component: Packs,
  },
  {
    path: "/success-payment",
    name: "Success Payment",
    component: SuccessPayment,
  },
  {
    path: "/fail-payment",
    name: "Fail Payment",
    component: FailPayment,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

const free_pages = ['Sign In', 'Sign Up', 'Reset Password', 'Reset Password After Mail', 'Success Payment', 'Fail Payment' ];

router.beforeResolve((to, from, next) => {
    
    let logueado = localStorage.user_logged != null && localStorage.user_logged == 'true';

    if (free_pages.indexOf(to.name ?? '') == -1 && !logueado) next({ name: 'Sign In' });  // quiere ir a una p�gina QUE NO ES LIBRE y NO est� logueado (mando al login)
    else if (to.name === 'Sign In' && logueado) next({ name: 'Database' });      // quiere ir al Login y SI est� logueado (mando a la home)
    else next();
});

export default router;
